<template>
	<div class="home">   
		<div id="demo-content">
			<div id="content" >         
				<picture>
      			<source rel="preconnect" v-bind:alt="url_images"  v-bind:srcset="url_images + portadas[1]" type="image/webp" class="portadas">
      			<source rel="preconnect" v-bind:alt="url_images" v-bind:srcset="url_images + portadas[2]" type="image/jp2"  class="portadas">
      			<img v-bind:alt="url_images" rel="preconnect" v-bind:src="url_images + portadas[0]"  class="portadas">     
    			</picture>      			   
	    		<div class="div-titulo">                   
	            		<label id="titulo">Atención al Cliente</label>     
	        </div>
          <div id="capa1">            
            <div class="text-justify alinear">
              <div class="card-body texto-principal">
                    <p>{{ textoEncuesta }}</p>
              </div>
            </div>              
              <div class="card-body">
                <div class="card-padre" v-for="question in questions" v-bind:key="question.id_question" style="padding-bottom: 15px;">
                      <p>{{ question.question }}</p>  
                      <div  v-if="question.id_tipo_question == 30 /*abierta*/">
                          <input type="text"  class="form-control sin-bordes" placeholder="Tu respuesta" v-bind:id="'answer'+question.id_question"  />
                          <div v-bind:id="'validate'+question.id_question" class="div-padre-alertas">
                            <div class="div-hijo-alertas">
                              <i class="fas fa-exclamation-triangle css-icon"></i>
                              <small class="css-small">Esta pregunta es obligatoria.</small>
                            </div>
                          </div>
                      </div>
                      <div v-if="question.id_tipo_question == 29 /*Radio*/">
                          <div class="css-radio">
                            <input v-bind:name="'check'+question.id_question" v-bind:id="'answer'+option.id_question_option" type="radio" v-for="option in options" v-bind:value="option.id_question_option" v-if="question.id_question == option.id_question" v-bind:key="option.id_question_option">
                          </div>
                          <div  class="css-radio">
                            <label v-for="option in options" v-bind:key="option.id_question_option" v-if="question.id_question == option.id_question">{{ option.option }}</label>
                          </div>
                          <div v-bind:id="'validate'+question.id_question" class="div-padre-alertas">
                            <div class="div-hijo-alertas">
                              <i class="fas fa-exclamation-triangle css-icon"></i>
                              <small class="css-small">Esta pregunta es obligatoria.</small>
                            </div>
                          </div>
                      </div>
                      <div v-if="question.id_tipo_question == 31 /*Seleccionar*/">
                          <select v-bind:id="'answer'+question.id_question" class="form-control">                           
                            <option v-for="option in options" v-bind:key="option.id_question_option" v-bind:value="option.id_question_option" v-if="question.id_question == option.id_question">{{option.option}}</option>
                          </select>
                          <div v-bind:id="'validate'+question.id_question" class="div-padre-alertas">
                            <div class="div-hijo-alertas">
                              <i class="fas fa-exclamation-triangle css-icon"></i>
                              <small class="css-small">Esta pregunta es obligatoria.</small>
                            </div>
                          </div>
                      </div>
                </div>
              </div>  
                <div class="card-body" style="padding-top: 20px;">
                  <button v-bind:style="{backgroundColor : color_botones}" @click="finalizarEncuesta()" class="boton-finalizar">Finalizar Encuesta</button>
              </div>    
        </div><!-- fin capa1--> 
        <div id="capa2" style="display: none;">
          <div class="card-body texto-principal">
              <p style="font-weight: 500;font-size: 20px;">! Gracias por ayudarnos a mejorar !</p>
          </div>
        </div>              
			</div><!-- fin content -->
		</div><!-- fin demo-content -->
  
	</div>
</template>
<style>
  .css-small{
    color:red;    
  }
  .css-icon{
    margin-right: 0.45rem;
    color:red;    
  }
  .div-padre-alertas{
    display: none;    
  }
  .div-hijo-alertas{
    display: flex;
    margin-top: 10px;
  }
  .boton-finalizar{
    border: none;
    outline: 0;    
    color: white;    
    text-align: center;
    cursor: pointer;    
    font-size: 16px;
    font-weight: 600;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 7px;
    padding-bottom:7px;
    font-family: FontAwesome;
    font-family: "Font Awesome 5 Free";
    border-radius: 10px; 
    width: 95%;   
  }  
	#content{
		width: 100% !important;
	}	
	.div-titulo{  
      text-align: left ! important;  	
    	margin-left: 5px;
    	margin-top: 20px;
    	width: 90% !important;
    	margin-bottom: 10px;
  }  	
  .alinear{
      margin:0;
  }
  .css-radio{
    text-align: center;
  }
  .css-radio input[type="radio"]{
    margin-right: 15px !important;
    margin-left: 15px !important;
  }
  .css-radio label{
    margin-right: 18px !important;
    margin-left: 18px !important;
  }

  input[type="radio"]{
    border-color: gray !important;
  }
  .sin-bordes{
    border: none !important;
    border-bottom: 2px solid gray !important;    
  }
  .sin-bordes:focus{
    outline: none !important;
    box-shadow: none !important;
    /*border-bottom: 2px solid skyblue !important;*/
    transition: all .9s ease-in-out !important;
  }
  .texto-principal p{
    padding-left: 15px;
    padding-right: 15px;
  }
  	.portadas{
    	width: 100%;
    	height: auto;
  	}
  	body{
    	padding:0;
    	margin:0;
  	}
  	@supports(object-fit: cover){
	    .portadas{
	      height: 100%;
	      object-fit: cover;
	      object-position: center center;
	    }
  	}
    .card-padre{
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);     
      display: inline-block;    
      text-align: left;
      font-family: arial;
      margin-left: 10px;
      display: block;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 10px;
      padding: 10px;

    }

    
</style>
<script>	
	import Vue from 'vue'
	import Vuesax from 'vuesax'
	import axios from 'axios';
	import { osName } from 'mobile-device-detect';
	import 'vuesax/dist/vuesax.css' //Vuesax styles
  	Vue.use(Vuesax, {
    // options here
  	})

  	export default {
  		data() {
  			return {
  				url: 'https://back.vinapp.co/api/company/post-data-company-questions-v2',
          url_save: 'https://back.vinapp.co/api/question/save-questions-client',
          redirect:'',
  				id_client: this.$route.params.id_client,
  				nameOS: osName,
  				companieName: 'Vinapp',
  				url_images:null,
  				portadas: [],
  				logos:[],
          textoEncuesta: null,
          questions: [],
          options:[],
          color_botones: null,
          answer:[],
          form: {
            id_client: this.$route.params.id_client,
            answers : []         
          }
  			}
  		},      
  		methods:{ 
  			setupCompanieQuestions(){  
           
          var data = new FormData();
          data.append('id_client', this.id_client); 
  				axios.post(this.url,data)
  				.then(res => {
  					if(res.data.statusCode == 200){
  						this.companieName = res.data.store.name;
  						this.portadas = res.data.store.portadas;
  						this.logos = res.data.store.logos;
  						this.url_images = res.data.url_images              
  						document.getElementById("titulo").style = `color:${res.data.store.color_letra}`;
              this.color_botones = res.data.store.color_letra;
              this.textoEncuesta = res.data.store.texto_encuesta;
              this.questions = res.data.questions;
              this.options = res.data.questionOption;
              this.redirect = 'https://vinapp.co/'+res.data.store.uri;
  					}
  				})
		        .catch(err => {
		            console.log(err);      
		        });
  			},
        validarCampos(){
          var self = this;
          var arrayRadio= []; 
          var arrayQuestionSelected = [];
          var validate = true            
          self.options.forEach(function(option){    
            if(option.id_tipo_question == 29 /*Radio*/){
              if(document.getElementById("answer"+option.id_question_option).checked){  
                 arrayRadio.push(option)
                 arrayQuestionSelected.push(option.id_question)    
              }  
            }
          });  

          this.questions.forEach(function(question){            
            if(question.id_tipo_question == 29 /*Radio*/){                
                let filter = arrayQuestionSelected.includes(question.id_question)
                if(!filter){
                    document.getElementById("validate"+question.id_question).style.display = 'block';
                    validate = false
                }else{
                    document.getElementById("validate"+question.id_question).style.display = 'none';
                }

              }else{
                   if(!document.getElementById("answer"+question.id_question).value){
                       document.getElementById("validate"+question.id_question).style.display = 'block';
                       validate = false
                   }else{
                       document.getElementById("validate"+question.id_question).style.display = 'none';
                   }          
              }
          })
          return validate
        },
        finalizarEncuesta(){        
          var self = this;
          self.form.answers = [];
          if(!this.validarCampos()) return false;
          this.questions.forEach(function(question){
              if(question.id_tipo_question == 29 /*Radio*/){
                self.options.forEach(function(option){
                  if(option.id_question == question.id_question){
                    if(document.getElementById("answer"+option.id_question_option).checked){
                        self.form.answers.push({
                          'id_tipo_question' : question.id_tipo_question,
                          'id_question' : question.id_question,
                          'id_question_option' : document.getElementById("answer"+option.id_question_option).value
                        });                        
                    }
                  }                  
                });
              }else{             
                self.form.answers.push({
                  'id_tipo_question' : question.id_tipo_question,
                  'id_question' : question.id_question,
                  'id_question_option' : document.getElementById("answer"+question.id_question).value
                });                  
              }
          });

          axios.post(this.url_save,this.form)
          .then(res => {
            if(res.data.statusCode == 200){              
              document.getElementById("capa1").style.display = 'none';
              document.getElementById("capa2").style.display = 'block';
              setTimeout(function(){  window.open(self.redirect,'_self')}, 3000);
            }
          })
          .catch(err => {
            console.log(err);      
          });
        }
  		},
  		mounted() {                        
  			this.setupCompanieQuestions();        
  		}
  	}
</script>

